import { styled } from '@mui/system'
import { TableCell } from '@mui/material'

export const StatisticsEditTableAddNewButtonCaption = styled('caption')(() => ({
  textAlign: 'center !important',
}))

export const StatisticsEditTableTableCell = styled(TableCell)(() => ({
  width: 'calc(100% / 3)',
  minWidth: '10rem',
}))
